'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

declare global {
  interface Window {
    __GA_MEASUREMENT_ID__?: string;
    gtag?: (...args: unknown[]) => void;
  }
}

/** Sends page_view on client navigations (initial load is handled by GoogleAnalyticsScripts). */
export function GoogleAnalyticsPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const id = window.__GA_MEASUREMENT_ID__;
    if (!id || typeof window.gtag !== 'function') {
      return;
    }
    const qs = searchParams.toString();
    const path = `${pathname}${qs ? `?${qs}` : ''}`;
    window.gtag('config', id, { page_path: path });
  }, [pathname, searchParams]);

  return null;
}
